@if (shouldShow()) {
    <div
        class="relative flex flex-row items-center justify-center p-[12px] w-full bg-[#F8E2E2] rounded-none bp908:rounded-[16px] cursor-pointer shadow-p-form-field-shadow overflow-hidden border-[2px] border-blurple-2"
        [ngClass]="{ 'animation-elastic-z-entry animation-delay-1': !viewportService.isMobile() }"
        (click)="onClickYearInFocus()">
        <div
            class="absolute bg-confetti-blue-pattern bg-center w-full h-full"
            [ngClass]="{
                'bg-[length:50%] bg-repeat': viewportService.isMobile(),
                'bg-cover bg-no-repeat': !viewportService.isMobile(),
            }">
            <img
                class="absolute left-0 h-[150%] translate-y-[-25%]"
                src="/assets/images/year-in-review/computer.webp" />
        </div>
        <div class="z-[1] w-full text-center text-primary font-semibold text-lg leading-5"
            >Year in Focus</div
        >
        @if (viewportService.isMobile()) {
            <fa-icon
                class="absolute top-2 right-2 text-[14px] text-primary z-[2] cursor-pointer hover:opacity-80 transition-opacity"
                [icon]="faTimes"
                (click)="onDismiss($event)">
            </fa-icon>
        }
    </div>
}
